
import apiRequest from "./apiRequest";

export const sh2RegisterApi = {

    fetchSh2Register: (accountId, token) => {
    return apiRequest(`/api/register/sh2?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitSh2Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/sh2?accountId=${accountId}`, 'POST', token, formData);
  },

 

  
};